module.exports = {
  NAME: "Prod",
  //Urls should not have trailing slash
  SERVER_URL: "https://diced.onrender.com",
  // SERVER_URL:
  //   "https://2vnch5ux53.execute-api.us-east-1.amazonaws.com/production",
  CLIENT_URL: "https://app.diceddigital.io",
  LANDING_URL: "https://diceddigital.io",
  SENTRY_DNS:
    "https://c2f9ef3358264838bec6466c8d050902@o4505052826959872.ingest.sentry.io/4505052828205056",
};
